import {createGlobalStyle} from 'styled-components';

export default createGlobalStyle`
    .App{
        padding-bottom: 90px;
    }
`;